// Salesforce limits shared by the post-meeting form (client) and the SFDC write path (server).
// Skills__c, Skill_Comments__c and Goals_and_Interests__c are Long Text Area(4000);
// Talent_Preference_Internal__c is Long Text Area(131072) — verified in the org setup.
export const SFDC_LONG_TEXT_LIMIT = 4000;
export const SFDC_TALENT_PREFERENCE_LIMIT = 131072;
// Form fields subject to the limit, keyed by their PostMeetingForm property names.
export const POST_MEETING_LIMIT_FIELDS = [
    "skills",
    "skillsComments",
    "goalsAndInterests",
    "locationComments",
];
// Length of the exact payload written to Skills__c, JSON formatting included.
export function measureSkillsPayload(skills) {
    return JSON.stringify({ skills }).length;
}
